import { useCallback, useState } from "react";
import createFullContext from "../../utils/createFullContext";
import { getNoticeForToday } from "./helpers";
import { NoticeContextType, NoticeProviderProps, NoticeState } from "./types";

export const [NoticeContextProvider, useNoticeContext] =
    createFullContext<NoticeContextType>("Missing NoticeProvider context");

export const NoticeProvider = ({ children }: NoticeProviderProps) => {
    const [value, setValue] = useState<NoticeState>(() => getNoticeForToday());

    const dismiss = useCallback(() => {
        setValue((prev) => ({ ...prev, active: false }));
    }, []);

    return (
        <NoticeContextProvider
            value={{
                ...value,
                dismiss,
            }}
        >
            {children}
        </NoticeContextProvider>
    );
};
